import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface EyeOpen extends SVGProps<SVGSVGElement> {
  label?: string
}

const EyeOpen: React.FC<EyeOpen> = ({ label = 'eyeOpen', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="eye-open-svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.983887 10C1.76722 5.73333 5.50639 2.5 9.99972 2.5C14.4931 2.5 18.2314 5.73333 19.0156 10C18.2322 14.2667 14.4931 17.5 9.99972 17.5C5.50639 17.5 1.76805 14.2667 0.983887 10ZM9.99972 14.1667C11.1048 14.1667 12.1646 13.7277 12.946 12.9463C13.7274 12.1649 14.1664 11.1051 14.1664 10C14.1664 8.89493 13.7274 7.83512 12.946 7.05372C12.1646 6.27232 11.1048 5.83333 9.99972 5.83333C8.89465 5.83333 7.83484 6.27232 7.05344 7.05372C6.27204 7.83512 5.83305 8.89493 5.83305 10C5.83305 11.1051 6.27204 12.1649 7.05344 12.9463C7.83484 13.7277 8.89465 14.1667 9.99972 14.1667ZM9.99972 12.5C9.33668 12.5 8.70079 12.2366 8.23195 11.7678C7.76311 11.2989 7.49972 10.663 7.49972 10C7.49972 9.33696 7.76311 8.70107 8.23195 8.23223C8.70079 7.76339 9.33668 7.5 9.99972 7.5C10.6628 7.5 11.2986 7.76339 11.7675 8.23223C12.2363 8.70107 12.4997 9.33696 12.4997 10C12.4997 10.663 12.2363 11.2989 11.7675 11.7678C11.2986 12.2366 10.6628 12.5 9.99972 12.5Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default EyeOpen
